<template>
  <img
    v-if="flagPath"
    :loading="lazy ? 'lazy' : 'eager'"
    :src="flagPath"
    width="25"
    height="12"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

const imageModules = import.meta.glob('@/components/flags/images/*.svg', {
  query: '?url',
  eager: true,
})

@Component
class PuFlag extends Vue {
  @Prop()
  countryIso: string

  @Prop({ default: true })
  lazy: boolean

  get flagPath() {
    return imageModules[`/components/flags/images/${this.countryIso}.svg`]
      ?.default
  }
}

export default toNative(PuFlag)
</script>

<style scoped>
img {
  width: auto;
  height: 0.75em;
  vertical-align: middle;
}
</style>
